/* istanbul ignore file */

export const isProduction = process.env.NODE_ENV === "production";
export const isDevelopment = process.env.NODE_ENV === "development";

export default {
  isProduction,
  isDevelopment,
};
